module.exports = __webpack_public_path__ + "img/one_platform.9f52e903.jpg";